/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { getNotasDePedidoCategory } from "../../../services/notasDePedidoServices";
import useFetcher from "../../../hooks/useFetcher";
import { getEstadoByValue } from "../utils";
import { multiPostCandidatosNp } from "../../../services/candidatosNPServices";
import { StyledSpinnerButton } from "../../../ui/buttons";

const ExistingCandidateModal = ({ toggle, isOpen, info, notaDePedidoId, setReloadCandidatos, setReloadDerivaciones, main, setDescartarCandidatoRepetidos }) => {
  const [categories] = useFetcher(getNotasDePedidoCategory, undefined);
  const [selectedRows, setSelectedRows] = useState([]);
  const [uploadingCandidatos, setUploadingCandidatos] = useState(false);

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);
  const handelContinuar = async () => {
    setUploadingCandidatos(true);
    let candidatosToPost;
    if (info.length > 1) {
      candidatosToPost = {
        notaDePedidoId,
        derivacionId: selectedRows[0].derivacionId || null,
        candidatosDetalle: selectedRows.map((row) => ({ id: row.id, cuil: row.cuil })),
      };
    } else {
      candidatosToPost = {
        notaDePedidoId,
        derivacionId: selectedRows.length > 0 ? selectedRows[0].derivacionId : null,
        candidatosDetalle: [{ id: info[0].id, cuil: info[0].cuil }],
      };
    }
    const { message } = await multiPostCandidatosNp(candidatosToPost);
    toast.success(message);
    setUploadingCandidatos(false);
    setReloadCandidatos(true);
    toggle();
    if (!main) setReloadDerivaciones(true);
  };
  return (
    <div>
      <Modal isOpen={isOpen} centered size="lg">
        <ModalHeader toggle={toggle} className="border-0 pb-0" />
        <ModalBody className="pt-1 mt-0" style={{ alignItems: "flex-start !important" }}>
          <>
            <FontAwesomeIcon icon={faWarning} className="mr-2" size="x3" color="#F0292A" style={{ height: "50px" }} />
            <div className="m-3" style={{ overflow: "auto", width: "-webkit-fill-available", fontFamily: "Nunito" }}>
              <DataTable
                // customStyles={tableCustomStyles}
                data={info}
                title={<h6 className="m-0 bold">{info.length > 1 ? "Candidatos en procesos anteriores:" : "Candidato en procesos anteriores:"}</h6>}
                noDataComponent={
                  <div className="p-3">
                    <b>No se encontraron candidatos</b>
                  </div>
                }
                selectableRows={info.length > 1}
                onSelectedRowsChange={handleRowSelected}
                contextMessage={{
                  singular: "Candidato seleccionado",
                  plural: "Candidatos seleccionados",
                }}
                columns={[
                  {
                    name: "Nota Id",
                    selector: (row) => row.notaDePedidoId,
                    center: true,
                    compact: true,
                    width: "100px",
                    style: {
                      textAlign: "center",
                    },
                  },
                  {
                    name: "CUIL",
                    selector: (row) => row.cuil,
                    sortable: true,
                    center: true,
                    style: {
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Estado",
                    selector: (row) =>
                      row.estado ? (
                        <>
                          <p id={`estado${row.id}`}>{getEstadoByValue(row.estado, categories && categories.estadoCandidatoNP && categories.estadoCandidatoNP.type)}</p>
                        </>
                      ) : (
                        ""
                      ),
                    center: true,
                    // compact: true,
                    style: {
                      textAlign: "center",
                      cursor: "pointer",
                    },
                  },
                ]}
              />
            </div>
          </>
        </ModalBody>
        <ModalFooter className="border-0 mt-0 pt-0">
          <div className=" mt-3 mb-0 d-flex justify-content-end">
            <Button
              color="btn-secondary mr-2"
              onClick={() => {
                if (setDescartarCandidatoRepetidos) setDescartarCandidatoRepetidos(info);
                toggle();
              }}
            >
              {info.length > 1 ? "No deseo avanzar con estos candidatos" : "No deseo avanzar con este candidadato"}
            </Button>
            <StyledSpinnerButton
              isLoading={uploadingCandidatos}
              className="btn px-2 py-1 text-center"
              style={{ backgroundColor: "#F0292A", color: "white", minWidth: "300px" }}
              onClick={() => handelContinuar()}
              type="button"
            >
              {info.length > 1 ? "Deseo continuar con los candidatos seleccionados" : "Deseo continuar de todas formas"}
            </StyledSpinnerButton>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ExistingCandidateModal;
